import { useGetAgentsInAgency } from '@urbanx/agx.agencies.client';

const VendorBuyersPreloader = () => {
  useGetAgentsInAgency();

  return <></>;
};

export default VendorBuyersPreloader;
